import { render, staticRenderFns } from "./InputMensaje.vue?vue&type=template&id=802f308a"
import script from "./InputMensaje.vue?vue&type=script&lang=js"
export * from "./InputMensaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports